export const trackPageView = (url) => {
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }

    gtag('event', 'page_view', {
        page_path: url,
    });
};

export const trackFormSubmitted = (formName = 'default') => {
    if (window.dataLayer) {
        window.dataLayer.push({
            event: 'FormSubmitted',
            form_name: formName, // Puedes pasar el nombre del formulario
            timestamp: new Date().toISOString(), // Opcional: agrega una marca de tiempo
        });
    }
};

export const updateConsent = (granted = true) => {
    const status = granted ? 'granted' : 'denied';
    console.log(`[DEBUG Consent Flow] updateConsent called with granted=${granted}, status=${status}`);
    
    // Si la función global existe, usarla (recomendado para Consent Mode)
    if (typeof window.gtag === 'function') {
        console.log("[DEBUG Consent Flow] window.gtag exists. Calling window.gtag('consent', 'update', ...)");
        window.gtag('consent', 'update', {
            'ad_storage': status,
            'ad_user_data': status,
            'ad_personalization': status,
            'analytics_storage': status
        });
    } else {
        console.log("[DEBUG Consent Flow] window.gtag DOES NOT exist. Falling back to localGtag over dataLayer.push(arguments).");
        window.dataLayer = window.dataLayer || [];
        // Intentar crear una función local que envíe "arguments" real
        function localGtag() { 
            window.dataLayer.push(arguments); 
        }
        localGtag('consent', 'update', {
            'ad_storage': status,
            'ad_user_data': status,
            'ad_personalization': status,
            'analytics_storage': status
        });
    }

    // Forzar un evento de actualización para disparar los triggers
    console.log(`[DEBUG Consent Flow] Pushing 'cookie_consent_update' and 'consent_updated' events to dataLayer with status=${status}`);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'cookie_consent_update', // Nombre de evento común para Cookiebot
        consent_status: status
    });
    
    window.dataLayer.push({
        event: 'consent_updated',
        consent_status: status
    });
};